
import React from 'react';

// const moneySymbol = '₲'; // this is a G with a line through it
// const moneySymbol = '$';

export default class Money extends React.Component {
    render() {
        const opts = {
            style: 'currency',
            currency: 'USD',
            currencySign: 'accounting',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        };

        if (this.props.value || this.props.value === 0) {
            return <span className="numeric" > {this.props.value.toLocaleString([], opts)} </span>;
        }

        return (
            <span> N/A </span>
        );
    }
}
